import { render, staticRenderFns } from "./BranchSelection.vue?vue&type=template&id=31c501c3&scoped=true"
import script from "./BranchSelection.vue?vue&type=script&lang=js"
export * from "./BranchSelection.vue?vue&type=script&lang=js"
import style0 from "./BranchSelection.vue?vue&type=style&index=0&id=31c501c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c501c3",
  null
  
)

export default component.exports